import isMobile from "../../../assets/js/isMobile";
import "./block-blog-cat-nav.scss";

const $ = jQuery.noConflict();

function initBlogCatNav() {
    $(".cat-nav__search-btn, .cat-nav__search-close").click(function onClick() {
        $(".cat-nav__search-form").toggleClass("cat-nav__search-form--active");
    });

    if (isMobile()) {
        $(".nav-item--all a").click(function onClick(event) {
            event.preventDefault();
            $(".cat-nav__submenu").slideToggle();
        });
    }
}

$(document).ready(function onReady() {
    initBlogCatNav();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", initBlogCatNav);
}
